<template>
    <Button
        color="carbon-400"
        :leftIcon="icon"
        size="l"
        :aria-label="$tr('gameContainer.share')"
        interfaceTarget="game-share"
        :class="$style.button_override"
        @click="handleShare"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Button from '@/components/Buttons/Button.vue'
import { useShareData } from '@/composables/use-share-data'

const props = defineProps<{
    shareData: ShareData
}>()

const { share, shared } = useShareData({
    successDuration: 3000,
})

const icon = computed(() => (shared.value ? 'check' : 'send'))

function handleShare() {
    share(props.shareData, 'game-container-share-button')
}
</script>

<style module>
.button_override {
    --background-color: var(--white-08);
    --border-width: 1px;
    --border-color: var(--white-08);
    flex: 1;
    padding: 12px;
}
</style>
